module.exports = __webpack_public_path__ + "img/clere-target.8313747d.svg";